import React, { PropTypes } from 'react';
import { injectIntl } from 'react-intl';
// Components
import Filter from './Filter';


const propTypes = {
  onFilterSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  filter: PropTypes.string,
};

const SearchBar = injectIntl(({ onFilterSubmit, intl, loading, filter }) => (
  <div>
    <Filter
      intl={intl}
      onFilterSubmit={onFilterSubmit}
      loading={loading}
      filter={filter}
    />
  </div>
));

SearchBar.propTypes = propTypes;

export default SearchBar;



/** WEBPACK FOOTER **
 ** ./src/components/layout/searchBar/SearchBar.js
 **/